import { PreferencesContext } from '@common/contexts/preferences';
import Translator from '@common/helpers/translator';
import { useContext } from 'react';

export const useTranslation = () => {
  const [{ lang }] = useContext(PreferencesContext);
  return Translator.getTranslator(lang);
};
